'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _history = require('history');

var history = _interopRequireWildcard(_history);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hashHistory;
var listerners = {},
    _options = {}; //{isAlias:()=>{}, toAlias:()=>{}, toRealName:()=>{}}

function setHistoryInstance() {
    if (!hashHistory) hashHistory = history.createHashHistory();
}

function config(options) {
    (0, _assign2.default)(_options, options);
}

function getAlias(pathName) {
    if (!_options.isAlias || !_options.toAlias || _options.isAlias(pathName)) return pathName;
    return _options.toAlias(pathName);
}

function getRealName(pathName) {
    if (!_options.isAlias || !_options.toRealName || !_options.isAlias(pathName)) return pathName;
    return _options.toRealName(pathName);
}

function listen(selfApp, handler) {
    setHistoryInstance();
    if (!listerners[selfApp]) {
        listerners[selfApp] = [];
    }

    var h = listerners[selfApp].find(function (o) {
        return o.listen == handler;
    });
    if (!h) {

        h = handler;
        var unlisten = hashHistory.listen(function (location, action) {
            var childApp = getChildApp(selfApp);
            handler(childApp, location, action);
        });

        listerners[selfApp].push({
            listen: h,
            unlisten: unlisten
        });
    }
}

function unlisten(selfApp, handler) {
    if (!listerners[selfApp]) return;

    var index = listerners[selfApp].findIndex(function (o) {
        return o.listen == handler;
    });

    if (index == -1) return;

    listerners[selfApp][index].unlisten();
    listerners[selfApp].splice(index, 1);
}

function getChildApp(selfApp) {
    setHistoryInstance();
    var pathName = hashHistory.location.pathname + hashHistory.location.search;
    pathName = getRealName(pathName);
    if (!pathName || pathName == '/' || pathName.indexOf(selfApp) == -1) return;

    var segs = pathName.split('/');

    var selfIndex = segs.findIndex(function (s) {
        return s.indexOf(selfApp) != -1;
    });

    if (segs.length - 1 == selfIndex) return;

    var ret = segs[selfIndex + 1];

    return ret == '/' ? undefined : ret;
}

function pushChildApp(selfApp, childApp) {
    setHistoryInstance();
    var pathName = hashHistory.location.pathname;
    pathName = getRealName(pathName);
    if (!pathName || pathName == '/' || pathName.indexOf(selfApp) == -1) {
        hashHistory.push(getAlias('/' + selfApp + '/' + childApp));
        return;
    }

    var segs = pathName.split('/');

    var selfIndex = segs.findIndex(function (s) {
        return s.indexOf(selfApp) != -1;
    });

    if (segs.length - 1 == selfIndex) {
        segs.push(childApp);
    } else {
        segs.splice(selfIndex + 1, segs.length - selfIndex, childApp);
        //segs[selfIndex + 1] = childApp
    }

    if (pathName == segs.join('/')) return;

    hashHistory.push(getAlias(segs.join('/')));
}

function goBack() {
    hashHistory.goBack();
}

exports.default = {
    config: config,
    listen: listen,
    unlisten: unlisten,
    getChildApp: getChildApp,
    pushChildApp: pushChildApp,
    goBack: goBack,
    location: hashHistory ? hashHistory.location : null
};
module.exports = exports['default'];